window.sound_fallback = {
    _: '..' + base + 'sounds/konami_base_fallback',
    _base: base,
    konami_bell: [ 52.7, 2.9 ],
    bell: [ 52.7, 2.9 ],
    trigger: [ 50.6, 2.1 ],
    drop: {
        '11': [ [ 29.3, 1.5 ], [ 30.9, 1.5 ], [ 32.4, 1.5 ], [ 34.0, 1.5 ], [ 35.5, 1.5 ] ],
        'DASS': [ [ 37.0, 2.8 ], [ 39.9, 2.6 ], [ 42.5, 2.4 ], [ 45.0, 2.5 ], [ 47.5, 2.4 ] ],
    },
    reel: [ [ 50.0, 0.6 ], [ 50.0, 0.6 ], [ 50.0, 0.6 ], [ 50.0, 0.6 ], [ 50.0, 0.6 ] ],
    reel_start: [ 138.4, 0.9 ],
    reel_stop: [ 139.3, 0.6 ],
    anticipate: {
        11: [ 145.2, 2.3 ],
    },
    multi_sweep: [ 133.9, 1.8 ],
    multi_sweep_twinkle: [ 135.4, 2.6 ],
    buttons: {
        denoms:{
            denom_0: [ 17.8, 0.9 ],
            denom_1: [ 16.8, 0.9 ],
            denom_2: [ 15.9, 0.9 ],
            denom_3: [ 22.3, 0.9 ],
            denom_4: [ 21.4, 0.9 ],
            denom_5: [ 20.5, 0.9 ],
            denom_6: [ 19.6, 0.9 ],
        },
        coins: {
            bet_0: [ 3.8, 0.6 ],
            bet_1: [ 3.2, 0.6 ],
            bet_2: [ 2.6, 0.6 ],
            bet_3: [ 4.3, 0.5 ],
            bet_4: [ 0.0, 0.5 ],
            bet_5: [ 0.5, 0.5 ],
            bet_6: [ 1.0, 0.5 ],
            bet_7: [ 1.5, 0.5 ],
            bet_8: [ 2.0, 0.5 ],
        },
        max: [ 24.8, 1.2 ],
        sound: [ 28.2, 1.0 ],
        help: [ 26.7, 0.8 ],
        close: [ 23.9, 0.9 ],
        next: [ 26.1, 0.7 ],
        prev: [ 27.6, 0.6 ],
    },
    freespin: {
        //default intro sound has bad timing for this title, used in freespin init
        background: [ 147.6, 40.8 ],
        waiting: [ 192.2, 31.2 ],
        smallTrigger: [ 188.3, 2.4 ],
        countUp: [ 190.8, 1.4 ],
    },
    latch: [ 133.0, 0.7 ],
    reveal: [ 139.9, 5.2 ],
    win: {
        //decor : 'decor',
        intro1: [ 229.7, 3.1 ],
        intro2: [ 232.8, 2.4 ],
        win_1: [ 235.3, 1.1 ],
        win_2: [ 236.4, 2.6 ],
        win_3: [ 239.1, 3.7 ],
        bigwin_1: [ 242.9, 5.4 ],
        bigwin_2: [ 248.3, 12.5 ],
        bigwin_3: [ 260.9, 15.9 ],
    },
};



/** WEBPACK FOOTER **
 ** ./public-src/js/konami_fallback.js
 **/